import { serviceTypes, modulesConfig } from '../config';

export const moduleId = 'Fitbit';
export const modulePath = serviceTypes[modulesConfig.Fitbit.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
